import React, { useEffect, useState } from 'react';
import { ContentItems, ApiInfo, AppStore, Redoc } from 'redoc';
import { trySwagger } from './utils/tryIt';
import { SwaggerUIBundle } from 'swagger-ui-dist';
import './App.css';
import precompiledState from './precompiled';

const TOKEN_KEY = 'tradovate-api-access-token'
const isDev = () => window.location.origin === 'https://api-d.tradovate.com'
// console.log(precompiledState)
if(isDev()) {
    precompiledState.spec.data.servers = [{url: 'https://demo-d.tradovateapi.com/v1'}]
}


const CustomRedoc = () => {
    const [store] = useState(AppStore.fromJS(precompiledState))
    let ui

    const swaggerConfig = {
        spec: precompiledState.spec.data,
        dom_id: `#swagger-ui`,
        tryText: `Interact`,            // try button text
        trySwaggerInApi: true,          // Is the swagger debugging window displayed under the api? true: yes, false: displayed after the request, when the request is relatively large, you may not see the debugging window
        authBtnPosSelector: `h1:eq(0)`, // where does auth button render
        authBtnText: `AUTHORIZE`,       
        onComplete: () => {             //run this on complete.
            trySwagger(swaggerConfig)
            let token = window.location.search.slice(1)?.split('=')[1]            
            if(token) {
                sessionStorage.setItem(TOKEN_KEY, token)
                window.location.replace(window.location.origin)
            }
            if(!token) {
                token = sessionStorage.getItem(TOKEN_KEY)
                if(token) {
                    ui.preauthorizeApiKey('bearer_access_token', token)
                }
            }
        },
    }
    
    //If you got here through dashboard redirect, get the query params and store them
    useEffect(() => {
        ui = SwaggerUIBundle(swaggerConfig)
    }, [])

    const outlet = (
        <>
            <ApiInfo store={store}/>
            <ContentItems items={store.menu.items}/>
        </>
    );

    return (
        <>
            <nav className="tv-nav">
                <div className="tv-nav-logo">
                    <a href="#">
                        <img src="/logo.png" height={50} />
                    </a>
                </div>
            </nav>
            <div className="custom-redoc-container">
                <Redoc outlet={outlet} store={store}/>
            </div>
            <div className={`swaggerBox hide`}>
                <div id="swagger-ui" />
            </div>
        </>
    );
}

const App = () => <CustomRedoc />;

export default App;